import { ChangeDetectionStrategy, Component, EventEmitter, Output, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Store } from '@ngxs/store';

import { AuthState } from '@data/state';
import { ApplicationRoleType } from '@data/enum';

interface NavItem {
    label: string;
    icon: string;
    route: string;
    roles?: ApplicationRoleType[];
}

const NAV_ITEMS: NavItem[] = [
    { label: 'Dashboard',      icon: 'mdi-view-dashboard-outline', route: '/dashboard' },
    { label: 'Companies',      icon: 'mdi-domain',                 route: '/companies',      roles: [ApplicationRoleType.SUPER_ADMIN] },
    { label: 'Supplier Verification', icon: 'mdi-check-decagram-outline', route: '/supplier-verification', roles: [ApplicationRoleType.SUPER_ADMIN] },
    { label: 'Users',          icon: 'mdi-account-group-outline',  route: '/users',          roles: [ApplicationRoleType.SUPER_ADMIN] },
    { label: 'Categories',     icon: 'mdi-shape-outline',          route: '/categories',     roles: [ApplicationRoleType.SUPER_ADMIN] },
    { label: 'Ideas & Occasions', icon: 'mdi-calendar-star',       route: '/ideas-occasions', roles: [ApplicationRoleType.SUPER_ADMIN] },
    { label: 'Products',       icon: 'mdi-package-variant-closed', route: '/products',       roles: [ApplicationRoleType.DISTRIBUTOR_SUPPLIER] },
    { label: 'Verification',   icon: 'mdi-check-decagram-outline', route: '/verification',   roles: [ApplicationRoleType.DISTRIBUTOR_SUPPLIER] },
    { label: 'Quotes',         icon: 'mdi-file-document-outline',  route: '/quotes',         roles: [ApplicationRoleType.DISTRIBUTOR_SUPPLIER] },
    { label: 'Newsletter',     icon: 'mdi-email-multiple-outline', route: '/newsletter-subscribers', roles: [ApplicationRoleType.SUPER_ADMIN] },
    { label: 'Messages',       icon: 'mdi-message-text-outline',   route: '/contact-messages',       roles: [ApplicationRoleType.SUPER_ADMIN] },
    { label: 'Configurations', icon: 'mdi-cog-outline',            route: '/configurations', roles: [ApplicationRoleType.SUPER_ADMIN] },
];

@Component({
    selector: 'app-side-nav',
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: './side-nav.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavComponent {
    @Output() collapsedChange = new EventEmitter<boolean>();

    private readonly _roleType = inject(Store).selectSignal(AuthState.roleType);

    collapsed = false;

    readonly isDistributorSupplier = computed(
        () => this._roleType() === ApplicationRoleType.DISTRIBUTOR_SUPPLIER,
    );

    readonly navItems = computed(() => {
        const role = this._roleType();
        return NAV_ITEMS.filter((item) => !item.roles || item.roles.includes(role!));
    });

    toggleSidebar(): void {
        this.collapsed = !this.collapsed;
        this.collapsedChange.emit(this.collapsed);
    }
}
